export const PAGE_SIZES = [10, 20, 50, 100];
export const ITEM_PAGE_SIZES = [20, 50, 100, 200];
